export default {
  sidebar: [
    {
      key: 'basic',
      path: 'basic'
    },
    {
      key: 'social',
      path: 'social'
    },
    {
      key: 'options',
      path: 'options'
    },
    {
      key: 'addons',
      path: 'addons'
    },
    {
      key: 'projects',
      path: 'projects'
    }
  ]
}
